module.exports = __webpack_public_path__ + "static/media/image-upload-icon.3f2eb3ab.svg";